"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionsController = void 0;
var ActionsController = /** @class */ (function () {
    function ActionsController() {
        var _this = this;
        this.isSubscribed = function (subscriber) {
            var isExist = false;
            if (_this.subscribers) {
                isExist = _this.subscribers.some(function (item) {
                    return item.type === subscriber.type && item.handler === subscriber.handler;
                });
            }
            return isExist;
        };
        // Add new subscription and return unSubscribe method
        this.performSubscribe = function (subscriber) {
            // Check if type and handler contains valid values, if not, skip subscription process and
            if (!subscriber.type || !subscriber.handler) {
                return null;
            }
            // if a subscriber not exist add new one to list with subscribers
            if (!_this.isSubscribed(subscriber)) {
                _this.addNewSubscriber(subscriber);
            }
            // return unSubscribe method
            return _this.unSubscribe.bind(_this, subscriber);
        };
        this.performUnSubscribe = function (subscriber) {
            // Filter out subscriber by type and handler from list of subscribers
            // if handler is null filter out all subscribers for passed type
            if (subscriber.type && _this.subscribers) {
                var filteredSubscribers = _this.subscribers.filter(function (item) {
                    return (item.type !== subscriber.type ||
                        (subscriber.handler && item.handler !== subscriber.handler));
                });
                if (_this.subscribers.length === filteredSubscribers.length) {
                    // tslint:disable-next-line:no-console
                    console.warn("Can't unsubscribe. Subscriber('s) with type=" + subscriber.type + "\n                " + (subscriber.handler ? 'and handler=' + subscriber.handler : '') + " not found.");
                }
                _this.subscribers = filteredSubscribers;
            }
        };
        this.addNewSubscriber = function (subscriber) {
            // Initialize subscribers list if it's empty
            if (!_this.subscribers) {
                _this.subscribers = [];
            }
            // Add new subscriber to list
            _this.subscribers.push(subscriber);
        };
        this.getSubscribersByType = function (type) {
            var result = null;
            if (type && _this.subscribers) {
                result = _this.subscribers.filter(function (item) { return item.type === type; });
            }
            return result && result.length > 0 ? result : null;
        };
    }
    ActionsController.prototype.subscribe = function (source) {
        var result = null;
        if (Array.isArray(source)) {
            result = source.map(this.performSubscribe);
        }
        else {
            result = this.performSubscribe(source);
        }
        return result;
    };
    ActionsController.prototype.unSubscribe = function (source) {
        if (Array.isArray(source)) {
            source.forEach(this.performUnSubscribe);
        }
        else {
            this.performUnSubscribe(source);
        }
    };
    // Execute matched subscribers handlers with action data witch are presented in subscribers list
    // return true if matched subscribers found otherwise return false
    ActionsController.prototype.dispatch = function (action) {
        // Find all subscribers by action type
        var subscribers = this.getSubscribersByType(action.type);
        // if subscribers found execute theirs handles with acton data and return true
        if (subscribers) {
            subscribers.forEach(function (item) {
                item.handler(action.data);
            });
            return true;
        }
        return false;
    };
    return ActionsController;
}());
var actionController = new ActionsController();
exports.ActionsController = actionController;
